
import Component from 'vue-class-component';
import {
  PilotagePracticeDetailsModel,
  PilotageType
} from "@/api-client";
import {Prop} from "vue-property-decorator";
import PracticePeriodsTable from "@/features/documents/practices/components/PracticePeriodsTable.vue";
import Files from "@/components/Files.vue";
import PracticeDetailsContentBase from "@/features/documents/practices/components/PracticeDetailsContentBase";
import HeadingGroup from "@/features/shared/components/HeadingGroup.vue";

@Component({
  components: {
    HeadingGroup,
    PracticePeriodsTable,
    Files
  },
})
export default class PracticePilotageDetailsContent extends PracticeDetailsContentBase {
  @Prop()
  details!: PilotagePracticeDetailsModel;
  @Prop()
  isOfficial?: boolean;

  get hasPracticePeriods(): boolean {
    return this.details.practicePeriods && this.details.practicePeriods.length > 0;
  }

  getPilotageTypeName(): string {
    if (this.details.pilotageType === PilotageType.Pilotage) {
      return this.$ls.Documents_Practices_PilotageType_Pilotage;
    } else if (this.details.pilotageType === PilotageType.PracticalPilotage) {
      return this.$ls.Documents_Practices_PilotageType_PracticalPilotage;
    }
    return this.$ls.Documents_Practices_PilotageType_Undetermined;
  }

  async getDownloadUrl(fileId: string): Promise<string> {
    // TODO: Use downloadPilotageFile when API client is regenerated
    return `/api/practices/pilotage/${this.details.id}/files/${fileId}`;
  }
}
